import { ChevronsUpDown } from 'lucide-react'
import type {
  PropertyTableSortColumnHeaderProps,
  PropertyTableSortIconProps,
} from '../types/components'
import { cn } from '@/lib/utils/helpers'
import styles from '@/features/invitee/styles/invitesParity.module.css'
import propertyStyles from '../styles/propertyListingSortHeader.module.css'

export function PropertyTableSortIcon({
  field,
  orderBy,
  sortBy,
}: PropertyTableSortIconProps) {
  const isActive = orderBy === field
  return (
    <span
      aria-hidden="true"
      className={cn(styles.sortIcon, propertyStyles.sortIcon, isActive && styles.sortIconActive)}
    >
      {isActive ? (sortBy === 'asc' ? '▲' : '▼') : <ChevronsUpDown className="h-3 w-3" />}
    </span>
  )
}

export function PropertyTableSortColumnHeader({
  field,
  orderBy,
  sortBy,
  onSort,
  children,
  className = '',
  align = 'start',
}: PropertyTableSortColumnHeaderProps) {
  return (
    <th
      data-testid={`property-table-sort-${field}`}
      className={cn(
        'cursor-pointer select-none',
        align === 'center' ? '!text-center' : '!text-left',
        className,
      )}
      onClick={() => onSort(field)}
    >
      <button
        type="button"
        className={cn(
          styles.sortHeaderButton,
          propertyStyles.sortHeaderButton,
          align === 'center' ? 'justify-center' : 'justify-start',
        )}
        onClick={(event) => {
          event.stopPropagation()
          onSort(field)
        }}
      >
        <span className={cn(styles.sortHeaderLabel, propertyStyles.sortHeaderLabel)}>{children}</span>
        <PropertyTableSortIcon field={field} orderBy={orderBy} sortBy={sortBy} />
      </button>
    </th>
  )
}
